export const windowWidth = window.innerWidth,
  windowHeight = window.innerHeight,
  mediumDownBreakPoint = window.matchMedia("(max-width: 1000px)"),
  mediumUpBreakPoint = window.matchMedia("(min-width: 1000px)"),
  xLargeUpBreakPoint = window.matchMedia("(min-width: 1200px)")

export function randomNumber(min, max) {
  return Math.floor(Math.random() * (max - min) + min)
}
